import React, { FC } from "react";
import { faStop } from "@fortawesome/pro-solid-svg-icons/faStop";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

export const Stop: FC<JSX.IntrinsicAttributes> = (props) => (
  <FontAwesomeIcon icon={faStop} {...props} />
);
